import { Injectable } from '@angular/core';
import { HttpClient } from './http-client.service';
import * as model from '../../models';
import { Logger } from '../logger.service';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';

export interface OrderQuery {
	orderNumber: string,
	customerFullName: string,
	orderDateFrom: string,
	orderDateTo: string,
	orderState: string,
	billingAddress: string,
	shippingAddress: string,
	completed?: boolean,
	canceled?: boolean,
	page: number,
	sort: string
}

@Injectable()
export class OrderApi {
	private orderURL = '/api/order-manager/v1';
	private deliveryURL = '/api/deliveries/v1'
	constructor(private httpClient: HttpClient, private logger: Logger) { }

	public getOrderByUuid(uuid: string): Observable<model.Order> {
		return this.httpClient.get(this.orderURL + "/" + uuid)
			.map(response => response.json())
	}

	public createOrder(orderDTO: model.OrderDTO): Observable<model.Order> {
		let body = JSON.stringify(orderDTO)
		return this.httpClient.post(this.orderURL, body)
			.map(response => <model.Order>response.json())
	}

	public confirmePayment(orderUUID: string): Observable<model.Order> {
		return this.httpClient.put(this.orderURL + "/" + orderUUID + "/" + "confirm_payment")
			.map(response => <model.Order>response.json())
	}

	public completeOrder(orderUUID: string): Observable<model.Order> {
		return this.httpClient.put(this.orderURL + "/" + orderUUID + "/" + "complete_order")
			.map(response => <model.Order>response.json())
	}

	public sendOrderCompletionMail(orderUUID: string) {
		return this.httpClient.post(this.orderURL + "/" + orderUUID + "/" + "sendOrderCompletionMail")
		.map(response => <model.Order>response.json())
	}

	public getDeliveryStatus(secureOrderId: string) {
		return this.httpClient.get(this.deliveryURL + "/" + secureOrderId + "/" + "status")
			.map(response => response.json())
	}

	public getTickets(orderUuid: string): Observable<model.Ticket[]> {
		return this.httpClient.get(this.orderURL + "/" + orderUuid + "/tickets")
			.map(reponse => reponse.json()._embedded.tickets)
	}

	public sendMail(secureOrderId: string, alternativeEmail: string) {
		let url = this.deliveryURL + "/" + secureOrderId + "/mail"
		if (alternativeEmail) {
			url = url + "?alternativeEmail=" + alternativeEmail
		}
		return this.httpClient.get(url)
	}

	public loadOrdersByCustomerUUID(uuid: string): Observable<model.Order[]> {
		this.logger.info("Get Orders by CustomerUuid:" + uuid);
		return this.httpClient.get(this.orderURL + "/search/findByCustomerUUID?customerUUID=" + uuid)
			.map(response =>{
				return <model.Order[]>response.json()._embedded.orderDatas
			})
			.catch(this.handleError);
	}

		public loadDisplayOrdersByCustomerUUID(uuid: string): Observable<model.DisplayOrder[]> {
		this.logger.info("Get DisplayOrders by CustomerUUID:" + uuid);
		return this.httpClient.get(this.orderURL + "/search/findDisplayOrdersByCustomerUUID?customerUUID="+uuid)
		.map (response => response.json()._embedded)
		.map (embedded => embedded? embedded.displayOrders : null)
		.catch(this.handleError);
	}

	public search(query: OrderQuery): Observable<model.PageableSearch<model.OrderData>> {
		const url = this.buildSearchUrl(query);
		return this.httpClient.get(url).map(response => response.json());
	}

	private buildSearchUrl(query: OrderQuery) {
		let url = this.orderURL + "/search/fullSearch" + "?"
		if (query.orderNumber)
			url += "&orderNumber=" + query.orderNumber
		if (query.customerFullName)
			url += "&customerFullName=" + query.customerFullName
		if (query.orderDateFrom)
			url += "&orderDateFrom=" + query.orderDateFrom
		if (query.orderDateTo)
			url += "&orderDateTo=" + query.orderDateTo
		if (query.orderState)
			url += "&orderState=" + query.orderState
		if (query.billingAddress)
			url += "&billingAddress=" + query.billingAddress
		if (query.shippingAddress)
			url += "&shippingAddress=" + query.shippingAddress
		if (query.completed === false || query.completed === true)
			url += "&completed=" + query.completed
		if (query.canceled === false || query.canceled === true)
			url += "&canceled=" + query.canceled
		if (query.sort)
			url += "&sort=" + query.sort
		url += "&page=" + query.page
		return url;
	}

	private handleError = (error: Response) => {
		this.logger.error(error);
		return Observable.throw(error);
	}
}



// WEBPACK FOOTER //
// ./src/app/services/webservice/order-api.service.ts